var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-page"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.Title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.detail.Content))]),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":_vm.del}},[_vm._v(_vm._s(_vm.GLOBAL.lanLocal['delete']))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4820b893","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/emailDetail.vue
// module id = null
// module chunks = 